<template>
  <ul class="menu-box">
    <li
      v-for="(item,key) in form"
      :key="key"
      :class="{'active':`${selected}`===`${item.id}`}"
      class="menu"
      @click="handleClick(item,key)">{{ item.value }}</li>
    <p
      v-if="isAdd"
      class="add-box">
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="$emit('onAdd')"
      >
        添加</el-button>
    </p>
  </ul>
</template>

<script>
  export default {
    name: "AppTree",
    props: {
      form: Array,
      isAdd: {
        type: Boolean,
        default: false,
      },
      // 选中id
      select: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        index: -1, // 选中索引
        selected: this.select, // 默认选中的值
      };
    },
    watch: {
      select(vl) {
        this.selected = vl;
      },
    },
    methods: {
      handleClick(item, key) {
        // this.index = key;
        this.$emit('onBack', item);
      },
    },
  };
</script>

<style scoped>
.menu-box{
    display: flex;
    flex-direction: column;
    border-right: 1px solid #eee;
}
.menu{
    width: 200px;
    line-height: 40px;
    padding: 10px 20px;
    color: #606266;
    transition: background-color .3s linear;
    position: relative;
}
.menu:hover{
    background-color: rgba(220, 220, 220, 0.4);
    cursor: pointer;
}
.menu.active{
  background-color: rgba(220, 220, 220, 0.4);
}
.menu.active:before{
  content: '';
  position:absolute;
  width: 5px;
  height: 100%;
  left: 0px;
  top: 0px;
  background-color: #f7ba2a;
}
.add-box{
    padding-left: 20px;
}
</style>
